import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import ReLoginModal from "../components/ReLoginModal";
import TopNav from "../layouts/TopNav";
import { CircularProgress } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import api from "../util/axios";

type Truck = {
    capacity: number;
    driver: string;
    plateNumber: string;
    truckNumber: string;
    createdAt: string;
};

const TruckTable = () => {
    const navigate = useNavigate();
    const token = window.localStorage.getItem("token");
    const [reLogin, setReLogin] = useState(false);
    const [getTrucks, setGetTrucks] = useState<Truck[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    function queryTrucks() {
        setIsLoading(true);
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        return api
            .get("/registered-trucks", {
                headers: headers,
            })
            .then((res) => {
                setIsLoading(false)
                setGetTrucks(res.data.data);
            })
            .catch((error) => {
                if (
                    error.response.data.message === "jwt expired" ||
                    error.response.data.message === "jwt malformed"
                ) {
                    setReLogin(true);
                } else {
                    setReLogin(false);
                }
                toast.error(error.response.data.message);
                setIsLoading(false)
            });
    }

    useEffect(() => {
        queryTrucks();
    }, []);

    return (
        <div className="board">
            <TopNav title="Registered Trucks" />
            <ToastContainer />
            {reLogin ? <ReLoginModal /> : null}
            <div className="p-12">
                <button onClick={(() => navigate(-1))} className="flex items-center cursor-pointer bg-red-400 hover:bg-red-500 text-white gap-2 py-1 px-10 rounded-lg"><BiArrowBack /> Back</button>

                <div className="invoiceTable !mt-8">
                    {isLoading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <CircularProgress />
                            <h2>Please wait while we process the request...</h2>
                        </div>
                    ) : (
                        <table className="inTable">
                            <tr className="heTable">
                                <th>Plate Number</th>
                                <th>Capacity</th>
                                <th>Driver</th>
                                <th>Truck id</th>
                                <th>Date registered</th>
                            </tr>

                            {getTrucks.map((truck, inx) => {
                                const formattedDate = new Date(truck.createdAt).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit",
                                });
                                return (
                                    <>
                                        <tr key={inx} className="taData">
                                            <td>{truck.plateNumber}</td>
                                            <td>{truck.capacity}</td>
                                            <td>{truck.driver}</td>
                                            <td>{truck.truckNumber}</td>
                                            <td>{formattedDate}</td>
                                        </tr>
                                    </>
                                );
                            })}
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TruckTable;
